import { isDefined } from '@aloft/toolkit-shared';
import { Document, Image } from '@react-pdf/renderer';

import { Page } from '../../../components/PdfExportV2/Page/Page.tsx';
import { Text } from '../../../components/PdfExportV2/Text/Text.tsx';
import { selectAllCommentaryData } from '../../../redux/features/selectors/commentarySelectors/selectAllCommentaryData.ts';
import { COMMENTARY_TEXT, PNG_HEIGHT, PNG_WIDTH } from '../consts.ts';
import { ExportChartContainer } from './ExportChartContainer.tsx';
import { ExportCommentarySection } from './ExportCommentarySection.tsx';
import { ExportCommentaryTable } from './ExportCommentaryTable.tsx';

export const ExportSiteExtraction = ({
  data: {
    siteExtraction: { data: tableData, helperText, commentary },
    subjectAddressDisplay,
  },
  charts: { siteSizeVsSiteValue, siteSizeVsCost },
}: {
  data: Pick<
    ReturnType<typeof selectAllCommentaryData>,
    'siteExtraction' | 'subjectAddressDisplay'
  >;
  charts: { siteSizeVsSiteValue?: string; siteSizeVsCost?: string };
}) => (
  <Document>
    <Page title="">
      <ExportCommentarySection
        subjectAddress={subjectAddressDisplay.full}
        {...COMMENTARY_TEXT['site-extraction']}
      >
        <ExportCommentaryTable
          data={tableData}
          helperText={helperText}
          configKey="siteExtraction"
        />
        {isDefined(siteSizeVsSiteValue) && (
          <ExportChartContainer title="Site Size vs Site Value">
            <Image src={siteSizeVsSiteValue} style={{ height: PNG_HEIGHT, width: PNG_WIDTH }} />
          </ExportChartContainer>
        )}
        {isDefined(siteSizeVsCost) && (
          <ExportChartContainer title="Site Size vs $/SF">
            <Image src={siteSizeVsCost} style={{ height: PNG_HEIGHT, width: PNG_WIDTH }} />
          </ExportChartContainer>
        )}
        {commentary && (
          <>
            <Text variant="h4">Commentary</Text>
            <Text variant="body1">{commentary ?? ''}</Text>
          </>
        )}
      </ExportCommentarySection>
    </Page>
  </Document>
);
